// saba-network/genesis/genesis.json, chain 23226:
// alloc balance 0x204fce5e3e25026110000000 = 10,000,000,000 SABA (18 decimals).
// This QBFT network has zero base fees and no block issuance/rewards.
export const SABA_CHAIN_ID = '23226';
export const SABA_TOTAL_SUPPLY = '10000000000';

export function getTotalSupply(chainId: string | undefined, reportedSupply?: string): string | undefined {
  if (chainId === SABA_CHAIN_ID) return SABA_TOTAL_SUPPLY;
  return reportedSupply && Number(reportedSupply) > 0 ? reportedSupply : undefined;
}

// SabaProjectRegistry, the catalogue the explorer's projects page is built from.
// Deployed on the devnet at this address; every other environment must set
// SABA_PROJECT_REGISTRY, because a wrong registry here would not fail loudly —
// it would quietly show an empty or foreign list of projects.
export const SABA_PROJECT_REGISTRY_DEVNET = '0x531442139143306ff90d116e46F34715E55170Ad';

export function getProjectRegistry(chainId: string | undefined): string | undefined {
  // Server-only, so it is read here rather than through the NEXT_PUBLIC config:
  // the address is not a secret, but nothing in the browser needs it.
  // eslint-disable-next-line no-restricted-properties
  const configured = process.env.SABA_PROJECT_REGISTRY?.trim();
  if (configured) return configured;
  return chainId === SABA_CHAIN_ID ? SABA_PROJECT_REGISTRY_DEVNET : undefined;
}
